// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"1edc8e66","523":"29c3ffa6","774":"0cc6b69d"}[chunkId] + ".chunk.js";
};